export enum SpecialEventDateState {
    Before = 'before',
    During = 'during',
    After = 'after',
}
